<template>
  <div class="PAUSED-LEADS-LIST-ITEM-PLACEHOLDER">
    <div class="TIME">
      <span class="x-pulse PLACEHOLDER" />
      <span class="x-pulse PLACEHOLDER" />
    </div>
    <div class="d-flex flex-1-1 fd-column p-l-2">
      <span class="x-pulse WIDE-PLACEHOLDER" />
    </div>
  </div>
</template>

<script>

export default {
  name: 'paused-leads-list-item-placeholder',
  components: {
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  @import "~@/views/Dashboard/constants";

  .PAUSED-LEADS-LIST-ITEM-PLACEHOLDER {
    display: flex;
    flex: 0 0 auto;
    min-height: $appointment-list-item-min-height;
    padding: 3*$unit;
    background-color: white;
    border-bottom: 1px solid $color-gray30;
  }

  .TIME {
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    width: 90px;
    padding-right: 2*$unit;
    border-right: 2px solid $color-gray30;
  }

  .PLACEHOLDER {
    @include rect(74px, 16px);
    margin: $unit/2 0;
  }

  .WIDE-PLACEHOLDER {
    @include rect(154px, 24px);
    margin-top: 0.75*$unit;
  }
</style>
